import { render } from "./Header.vue?vue&type=template&id=0a1ae16d&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0a1ae16d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1ae16d"]])

export default __exports__